const LineIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="2"
      height="49"
      viewBox="0 0 2 49"
      fill="none"
    >
      <path d="M0.999756 0.947113L1.04952 48.9471" stroke="#C2C2C2" />
    </svg>
  );
};
export default LineIcon;
